import script from "./KColourDot.vue?vue&type=script&setup=true&lang=ts"
export * from "./KColourDot.vue?vue&type=script&setup=true&lang=ts"

import "./KColourDot.vue?vue&type=style&index=0&id=54731a28&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54731a28"]])

export default __exports__